// Entry parameters the door handles (api-surface 1.4): ?invite=<token>,
// ?verify_email=<token>, ?reset_password=<token>, ?discord_auth=<status>.
// Pure parse over the search string; the router owns view and q.
export const AUTH_PARAMS = {
  invite: 'invite',
  verifyEmail: 'verify_email',
  resetPassword: 'reset_password',
  discordAuth: 'discord_auth',
} as const;

export type AuthScreen = 'door' | 'callback' | 'invitation' | 'verify' | 'reset';

export interface AuthParams {
  readonly invite: string | null;
  readonly verifyEmail: string | null;
  readonly resetPassword: string | null;
  readonly discordAuth: string | null;
  readonly screen: AuthScreen;
}

function clean(value: string | null): string | null {
  return value === null || value.trim() === '' ? null : value.trim();
}

export function parseAuthParams(search: string): AuthParams {
  const params = new URLSearchParams(search);
  const invite = clean(params.get(AUTH_PARAMS.invite));
  const verifyEmail = clean(params.get(AUTH_PARAMS.verifyEmail));
  const resetPassword = clean(params.get(AUTH_PARAMS.resetPassword));
  const discordAuth = clean(params.get(AUTH_PARAMS.discordAuth));
  const screen: AuthScreen = invite ? 'invitation' : verifyEmail ? 'verify' : resetPassword ? 'reset' : discordAuth ? 'callback' : 'door';
  return { invite, verifyEmail, resetPassword, discordAuth, screen };
}

// Removes the auth params from the URL without a navigation entry.
export function stripAuthParams(): void {
  const url = new URL(window.location.href);
  let changed = false;
  for (const name of Object.values(AUTH_PARAMS)) {
    if (url.searchParams.has(name)) { url.searchParams.delete(name); changed = true; }
  }
  if (!changed) return;
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  window.dispatchEvent(new Event('aleph:navigate'));
}
